import type { TFunction } from 'i18next'

import { toast } from 'sonner'

import { ANCHOR_IMPORT_TEMPLATE_COLUMNS } from '@/entities/anchor'

import Sentry from '@/shared/lib/sentry'
import { download } from '@/shared/tools/report'

// Headers stay untranslated on purpose: the API matches them against its own
// export labels, so a localized header row would be rejected as an unknown column.
export async function downloadImportTemplate(t: TFunction) {
	try {
		const Excel = await import('exceljs')
		const rows = [
			Object.fromEntries(
				ANCHOR_IMPORT_TEMPLATE_COLUMNS.map(({ field }) => [
					field,
					getExampleValue(field),
				])
			),
		]

		const workbook = new Excel.Workbook()
		workbook.creator = 'Competera'
		const worksheet = workbook.addWorksheet('Sheet1')
		worksheet.columns = ANCHOR_IMPORT_TEMPLATE_COLUMNS.map(
			({ field, header }) => ({
				header,
				key: field,
				width: 20,
				outlineLevel: 1,
			})
		)
		worksheet.addRows(rows)
		const buffer = await workbook.xlsx.writeBuffer()
		const blob = new Blob([buffer], {
			type: 'application/octet-binary;charset=utf-8',
		})
		download(blob, 'anchors_import_template.xlsx')
	} catch (error) {
		Sentry.captureException(error)
		toast.warning(t('fatal_error_title'), { id: 'export' })
	}
}

const getExampleValue = (field: string): string | number => {
	if (field === 'sku') return 's1'
	if (field === 'sales_entity_id') return 'se1'
	if (field === 'optimization_group_id') return ''
	if (field.endsWith('_source_family_id')) return 'f1'
	if (field.endsWith('_anchor_sku')) return 's2'
	if (field.endsWith('_anchor_mul')) return 1.5
	if (field.endsWith('_anchor_add')) return 0.25

	return ''
}
